import { createContext } from 'react';

export interface ITheme {
    palette: {
        primary: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        secondary: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        error: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        success: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        divider: string;
    },
    background: {
        default: string;
        paper: string;
        panel: string;
        card: string;
    },
    text: {
        primary: string;
        secondary: string;
        disabled: string;
        muted: string;
        contrast: string;
    },
    colors: {
        primary: string;
        secondary: string;
        accent: string;
        highlight: string;
        feature: string;
        ink: string;
        text: string;
        textMuted: string;
        bg: string;
        surface: string;
        surfaceAlt: string;
        border: string;
        // Legacy support
        green: {
            g1: string;
            g2: string;
            g3: string;
        },
        accentLegacy: {
            korea: string;
            egypt: string;
        },
        line: string;
    },
    gradients: {
        hero: string;
        sectionA: string;
        sectionB: string;
        button: string;
    },
    borderRadius: {
        r1: string;
        r2: string;
    },
    shadow: {
        shadow1: string;
        cardShadow: string;
        hoverShadow: string;
    }
}

export type TBreakpoint = {
    xs: boolean;
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
}

interface IThemeContext {
    theme: ITheme;
    breakpoint: TBreakpoint;
}

export const ThemeContext = createContext<IThemeContext | undefined>(undefined);